<template>
    <div class="pic-url">
        <img
            :class="{ fullImg: item.isFull }"
            @click="onFullImageUrl(item)"
            :src="item.url"
            v-for="item in picUrlList"
            :key="item.url"
        />
    </div>
</template>
<script>
export default {
    props: ['picUrl'],
    data() {
        return {
            picUrlList: [],
        }
    },
    created() {
        this.picUrlList = []
        if (this.picUrl) {
            this.picUrl.split(',').forEach((img) => {
                this.picUrlList.push({ url: img, isFull: false })
            })
        }
    },
    methods: {
        onFullImageUrl(item) {
            item.isFull = !item.isFull
        },
    },
}
</script>
<style lang="scss" scoped>
.pic-url {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 12px;
    img {
        width: 120px;
        height: 120px;
        object-fit: cover;
        flex-shrink: 0;
        cursor: pointer;
    }
    .fullImg {
        width: 100%;
        margin-right: 0;
        height: auto;
    }
}
</style>
